import '../style/footer.css'
import logo from './icons/logo.png'


export default function Footer(){


return(
<>

<div className='footer_div_1' ><a> <p className='footer_a1'>Back to top </p> </a> </div>
<div className='footer_div_2'>
    <div className='footer_div_2_1'>
     <p className='footer_div_2_p1'>Get to Know Us</p>
     <p className='footer_div_2_p2'>Careers</p>
     <p className='footer_div_2_p2'>Blog</p>
     <p className='footer_div_2_p2'>About Amazon</p>
     <p className='footer_div_2_p2'>Investor Relations</p>
     <p className='footer_div_2_p2'>Amazon Devices</p>
     <p className='footer_div_2_p2'>Amazon Science</p>

    </div>
    <div className='footer_div_2_1'>
     <p className='footer_div_2_p1'>Make Money with Us</p>
     <p className='footer_div_2_p2'>Sell products on Amazon</p>
     <p className='footer_div_2_p2'>Sell on Amazon Business</p>
     <p className='footer_div_2_p2'>Sell apps on Amazon</p>
     <p className='footer_div_2_p2'>Become an Affiliate</p>
     <p className='footer_div_2_p2'>Advertise Your Products</p>
     <p className='footer_div_2_p2'>Self-Publish with Us</p>
     <p className='footer_div_2_p2'>Host an Amazon Hub</p>
     <p className='footer_div_2_p2'>›See More Make Money with Us</p>

    </div>
    <div className='footer_div_2_1'>
     <p className='footer_div_2_p1'>Amazon Payment Products</p>
     <p className='footer_div_2_p2'>Amazon Business Card</p>
     <p className='footer_div_2_p2'>Shop with Points</p>
     <p className='footer_div_2_p2'>Reload Your Balance</p>
     <p className='footer_div_2_p2'>Amazon Currency Converter</p>
    

    </div>
    <div className='footer_div_2_1'>
     <p className='footer_div_2_p1'>Let Us Help You</p>
     <p className='footer_div_2_p2'>Amazon and COVID-19</p>
     <p className='footer_div_2_p2'>Your Account</p>
     <p className='footer_div_2_p2'>Your Orders</p>
     <p className='footer_div_2_p2'>Shipping Rates & Policies</p>
     <p className='footer_div_2_p2'>Returns & Replacements</p>
     <p className='footer_div_2_p2'>Manage Your Content and Devices</p>
     <p className='footer_div_2_p2'>Help</p>

    </div>
  


</div>

<div className='footer_div_3'>
   
    <div><img className='footer_div_3_logo' src={logo} /> </div>
    <div className='footer_div_3_2'>
        <p className='footer_div_3_p'>English</p>
        <p className='footer_div_3_p'>$ USD-U.S.dOLLAR</p>
        <p className='footer_div_3_p'>United States</p>
    </div>

</div>

<div className='footer_div_4'>
    
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Amazon Music</p>
      <p className='footer_div_4_p2' >Stream millions of songs</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Amazon Ads</p>
      <p className='footer_div_4_p2' >Reach customers
wherever they
spend their time</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>6pm</p>
      <p className='footer_div_4_p2' >Score deals
on fashion brands</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>AbeBooks</p>
      <p className='footer_div_4_p2' >Books, art
& collectibles</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>ACX</p>
      <p className='footer_div_4_p2' >Audiobook Publishing
Made Easy</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Sell on Amazon</p>
      <p className='footer_div_4_p2' >Start a Selling Account</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Veeqo</p>
      <p className='footer_div_4_p2' >Shipping Software
Inventory Management</p>

    </div>





<div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Amazon Business</p>
      <p className='footer_div_4_p2' >Everything For
Your Business</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>AmazonGlobal</p>
      <p className='footer_div_4_p2' >Ship Orders
Internationally</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Amazon Web Services</p>
      <p className='footer_div_4_p2' >Scalable Cloud
Computing Services</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Audible</p>
      <p className='footer_div_4_p2' >Listen to Books & Original
Audio Performances</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Box Office Mojo</p>
      <p className='footer_div_4_p2' >Find Movie
Box Office Data</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Goodreads</p>
      <p className='footer_div_4_p2' >Book reviews
& recommendations</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>IMDb</p>
      <p className='footer_div_4_p2' >Movies, TV
& Celebrities</p>

    </div>






    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>IMDbPro</p>
      <p className='footer_div_4_p2' >Get Info Entertainment
Professionals Need</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Kindle Direct Publishing</p>
      <p className='footer_div_4_p2' >Indie Digital & Print Publishing
Made Easy</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Prime Video Direct</p>
      <p className='footer_div_4_p2' >Video Distribution
Made Easy</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Shopbop</p>
      <p className='footer_div_4_p2' >Designer
Fashion Brands</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Woot!</p>
      <p className='footer_div_4_p2' >Deals and
Shenanigans</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Zappos</p>
      <p className='footer_div_4_p2' >Shoes &
Clothing</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Ring</p>
      <p className='footer_div_4_p2' >Smart Home
Security Systems</p>

    </div>




<div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>eero WiFi</p>
      <p className='footer_div_4_p2' >Stream 4K Video
in Every Room</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Blink</p>
      <p className='footer_div_4_p2' >Smart Security
for Every Home</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Neighbors App</p>
      <p className='footer_div_4_p2' >Real-Time Crime
& Safety Alerts</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Amazon Subscription Boxes</p>
      <p className='footer_div_4_p2' >Top subscription boxes – right to your door</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>PillPack</p>
      <p className='footer_div_4_p2' >Pharmacy Simplified</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Amazon Luna</p>
      <p className='footer_div_4_p2' >Video games from the cloud,
no console required</p>

    </div>
    <div className='footer_div_4_1'>
      <p className='footer_div_4_p1'>Blink</p>
      <p className='footer_div_4_p2' >Smart Security
for Every Home</p>

    </div>

</div>

<div className='copyRight'> 
  <br/>
  <p className='copy1'><span className='span_copy'> Conditions of Use </span> <span className='span_copy'> Privacy Notice</span> <span className='span_copy'>Consumer Health Data Privacy Disclosure</span> <span className='span_copy'>Your Ads Privacy Choices </span> </p>
<p className='copy2'>© 1996-2025, Amazon.com, Inc. or its affiliates</p>
</div>

</>
)
}